import { IRedirectionHandler, RedirectionHandlerProps } from './types';

export const mapRedirectionHandler = ({
  prismicContent,
}: {
  prismicContent: RedirectionHandlerProps['slice'];
}): IRedirectionHandler => {
  const { items, primary }: RedirectionHandlerProps['slice'] = prismicContent;

  return {
    items,
    primary,
  };
};
